import { SearchResult } from '../common/search/search-result';

export class SocialNetworkState {
  public content?: SearchResult;
  public id: number;
  public type: string;
}
